// OEM App 定制 — 上架平台 & 推送配置
// 用于二阶段「上架平台&推送」：勾选上架平台后，动态展示其推送 / 开发者账号字段。
// 所有字段均支持「填写」或「上传文件」。
// TODO: 联调时替换为接口数据

export const CN_APP_STORES = [
    {
        key: 'huawei', name: '华为/鸿蒙', push: true,
        fields: [
            { name: 'AppID', required: true },
            { name: 'Client ID', required: true },
            { name: 'API 密钥', required: true },
            { name: 'Client Secret', required: true },
            { name: 'agconnect-services.json', type: 'file', required: true },
        ],
    },
    {
        key: 'xiaomi', name: '小米', push: true,
        fields: [
            { name: 'AppID', required: true },
            { name: 'App Key', required: true },
            { name: 'App Secret', required: true },
            { name: '通道类别 ID', required: true },
        ],
    },
    {
        key: 'vivo', name: 'VIVO', push: true,
        fields: [
            { name: 'AppID', required: true },
            { name: 'App Key', required: true },
            { name: 'App Secret', required: true },
            { name: 'classification', required: false, placeholder: '默认 1' },
            { name: 'category', required: true },
        ],
    },
    {
        key: 'oppo', name: 'OPPO', push: true,
        fields: [
            { name: 'AppID', required: true },
            { name: 'App Key', required: true },
            { name: 'App Secret', required: true },
            { name: 'appserversecret', required: true },
            { name: '通道 ID', required: false, placeholder: '推送申请后获取' },
        ],
    },
    {
        key: 'honor', name: '荣耀', push: true,
        fields: [
            { name: 'AppID', required: true },
            { name: 'Client ID', required: true },
            { name: 'API 密钥', required: true },
            { name: 'Client Secret', required: true },
            { name: 'agconnect-services.json', type: 'file', required: true },
        ],
    },
    {
        key: 'yingyongbao', name: '应用宝', push: false,
        fields: [
            { name: 'AppID', required: true },
            { name: 'AppKey', required: true },
            { name: '应用宝授权标识（myapp_auth_key）', required: true },
        ],
    },
    {
        key: 'baidu', name: '百度', push: false,
        fields: [
            { name: 'Access Key', required: true },
            { name: 'Secret Key', required: true },
        ],
    },
];

// 海外上架平台的 Google 推送，作为独立资料项（fields 模式）配置，见 materialConfig。

export const ALL_STORES = [...CN_APP_STORES];
